export type AnalyticsQuery = {
  urlHosts: string[];
  metrics: MetricName[];
  order: Order;
  sortMetric: MetricName;
  ranges: QueryRanges;
  offset: number;
  limit: number;
  filters: AnalyticsQueryFilters;
  targetCurrency?:
    | "AED"
    | "AUD"
    | "BGN"
    | "BRL"
    | "CAD"
    | "CHF"
    | "CZK"
    | "DKK"
    | "EUR"
    | "GBP"
    | "HKD"
    | "HUF"
    | "IDR"
    | "ILS"
    | "INR"
    | "ISK"
    | "JPY"
    | "MXN"
    | "NOK"
    | "NZD"
    | "PHP"
    | "PLN"
    | "QAR"
    | "RON"
    | "RSD"
    | "SAR"
    | "SEK"
    | "SGD"
    | "THB"
    | "TWD"
    | "USD"
    | null;
};

export type AnalyticsResponse = {
  totalRowsCount: number;
  rangeResults: RangeResult[];
};

export enum ConditionOperatorEnum {
  EQUALS = "equals",
  DOES_NOT_EQUAL = "does_not_equal",
  CONTAINS = "contains",
  DOES_NOT_CONTAIN = "does_not_contain",
}

export type FilterCondition =
  | {
      operator: ConditionOperatorEnum.EQUALS;
      value: string[];
    }
  | {
      operator: ConditionOperatorEnum.DOES_NOT_EQUAL;
      value: string[];
    }
  | {
      operator: ConditionOperatorEnum.CONTAINS;
      value: string;
    }
  | {
      operator: ConditionOperatorEnum.DOES_NOT_CONTAIN;
      value: string;
    };

export type FilterConditions = FilterCondition[];

export type AnalyticsQueryFilters = {
  urlPath: FilterConditions;
  pageType: PageTypeEnum;
  urlParams: QueryFiltersUrlParams;
};

export type QueryRange = {
  id: string;
  startDatetime: number;
  endDatetime: number;
  interval: number;
};

export type QueryRanges = {
  mainRange: QueryRange;
  compareAtRanges: QueryRange[];
};

export type QueryFiltersUrlParams = { [x: string]: FilterConditions };

export type FindUrlParamsQuery = {
  urlHosts: string[];
  order: Order;
  offset: number;
  limit: number;
  key: string;
  value: string;
};

export type FindAggregatedQuery = {
  analyticsQuery: AnalyticsQuery;
  minSessionsThreshold: number;
};

export type FindAggregatedResponse = {
  aggregatedResults: AggregatedResult[];
};

export type FindUrlParamsResponse = {
  urlParams: string[];
};

export type MetricName =
  | "conversions"
  | "views"
  | "unique_sessions"
  | "conversion_rates"
  | "revenue"
  | "revenue_per_session"
  | "average_order_value";

export type Order = "ASC" | "DESC";

export enum PageTypeEnum {
  ALL_PAGES = "allPages",
  ENTRY_PAGES = "entryPages",
}

export type RangeResult = {
  urlPath: string;
  metadata: {
    elementId: string | null;
    title: string;
    url: string;
  };
  rangeId: string;
  metrics: { [x: string]: number[] };
};

export type AggregatedResult = {
  metric: "conversion_rates";
  group:
    | "all"
    | "homepage"
    | "/pages"
    | "/products"
    | "/collections"
    | "/blogs";
  average: number;
  median: number;
};

export type FindSubDomainsForUrlHostsResponse = {
  urlHost: string;
  isRootDomain: boolean;
}[];
